<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectVertical" });
import { SelectSingle } from "../../../../selects/index.js";
import { VERTICALS } from "../../config/verticals.js";
import { t } from "svelte-i18n";
export let key;
export let label = "resource.vertical.label";
export let options = void 0;
export let isDisabled = false;
export let isRequired = false;
export let whitelist = [];
export let blacklist = [];
const VERTICALS_WITH_LABEL = VERTICALS.map((vertical) => ({
    key: vertical.key,
    label: $t(vertical.label)
}));
$: OPTIONS = options === void 0 ? VERTICALS_WITH_LABEL : VERTICALS_WITH_LABEL.filter((vertical) => options.includes(vertical.key));
</script>

<SelectSingle
    bind:key = { key }
    placeholder = 'resource.vertical.placeholder'
    name = 'vertical.key'
    options = { OPTIONS }
    { whitelist }
    { label }
    { isDisabled }
    { isRequired }
    { blacklist }
/>